import { get } from './http';

// Types sourced from https://github.com/ev-proddev/checkout-services
// Paths below are relative to that repo root (checkout-services-xapi/src/main/java/com/experticity/checkoutservices/dto/cart/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @source CouponDto.java */
export type Coupon = {
  id: number;
  headline: string;
  termsConditions: string;
  endDate: string;
  minimum?: number;
  type: string;
  carts?: unknown[];
  restrictions?: unknown[];
};

/** @source CartSetsDto.java */
export type CartSets = {
  carts: unknown[];
  coupons: Coupon[];
  couponOffers: Coupon[];
  shippingAddress: unknown;
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getCarts(): Promise<CartSets> {
  return get<CartSets>('/xapi/checkout-services/ext/v2/carts');
}
